export enum ActorType {
  Natural = 'natural',
  Legal = 'legal',
  NaturalWithDocuments = 'naturalWithDocuments',
  BorrowerLegal = 'borrowerLegal',
  BorrowerNatural = 'borrowerNatural',
}
